module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-recepcao"
  }, [_c('h3', [_vm._v(" Recepção "), _c('span', {
    staticClass: "label label-warning"
  }, [_vm._v(_vm._s(this.unidadeNome(_vm.filial)))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade in active",
    attrs: {
      "role": "tabpanel",
      "id": "home"
    }
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('Agendado', {
    attrs: {
      "data": this.dia,
      "filial": this.filial,
      "acessoBotoes": this.permissaoBotoes
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('EmAtendimento', {
    attrs: {
      "data": this.dia,
      "filial": this.filial,
      "acessoBotoes": this.permissaoBotoes
    }
  }), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_c('Reagendar', {
    attrs: {
      "data": this.dia,
      "filial": this.filial,
      "acessoBotoes": this.permissaoBotoes
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "role": "tabpanel",
      "id": "relatorio"
    }
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isHabilitado),
      expression: "isHabilitado"
    }],
    staticClass: " ",
    staticStyle: {
      "margin-top": "7px"
    },
    attrs: {
      "for": "DataAgenda"
    }
  }, [_vm._v("Recepção do Dia: ")]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isHabilitado),
      expression: "!isHabilitado"
    }],
    staticClass: " ",
    staticStyle: {
      "margin-top": "7px"
    },
    attrs: {
      "for": "DataAgenda"
    }
  }, [_vm._v("Pesquisando... ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.diaSelecionado),
      expression: "diaSelecionado"
    }],
    staticClass: "form-control ",
    staticStyle: {
      "font-size": "19px"
    },
    attrs: {
      "type": "date",
      "id": "DataAgenda"
    },
    domProps: {
      "value": (_vm.diaSelecionado)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.diaSelecionado = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.pesquisar
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isHabilitado),
      expression: "isHabilitado"
    }],
    staticClass: "fa fa-search"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isHabilitado),
      expression: "!isHabilitado"
    }],
    staticClass: "fa fa-circle-o-notch fa-spin"
  })])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.resultado.length != 0),
      expression: "resultado.length != 0"
    }],
    staticClass: "text-right",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [(this.selecionados.length) ? _c('strong', {
    staticStyle: {
      "float": "left",
      "margin-top": "20px"
    }
  }, [_vm._v(_vm._s(this.selecionados.length) + " ficha(s) selecionada(s)")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "title": "Exportar para o GI "
    },
    on: {
      "click": _vm.exportarGi
    }
  }, [_c('i', {
    staticClass: "fa fa-upload",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  \n          Exportar para o GI \n        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtro),
      expression: "filtro"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisar"
    },
    domProps: {
      "value": (_vm.filtro)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filtro = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.resultado.length != 0),
      expression: "resultado.length != 0"
    }],
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('td', [_vm._v("Nome")]), _vm._v(" "), _c('td', [_vm._v("CPF")]), _vm._v(" "), _c('td', [_vm._v("Data Atend.")]), _vm._v(" "), _c('td', [_vm._v("Status ")]), _vm._v(" "), _c('td', [_vm._v("Tipo Atend.")]), _vm._v(" "), _c('td', [_vm._v("Obs. Atend.")]), _vm._v(" "), _c('td', [_vm._v("Vaga")]), _vm._v(" "), _c('td', [_vm._v("Ficha Aprov.")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectAll),
      expression: "selectAll"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.selectAll) ? _vm._i(_vm.selectAll, null) > -1 : (_vm.selectAll)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.selectAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.selectAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectAll = $$c
        }
      }
    }
  })])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredData), function(row) {
    return _c('tr', {
      key: row,
      staticStyle: {
        "width": "100% !important"
      }
    }, [_c('td', {
      staticStyle: {
        "width": "290px !important",
        "text-align": "left"
      }
    }, [(row.Candidato != null) ? _c('div', [_vm._v("\n                  " + _vm._s(row.Candidato.Nome) + " \n                ")]) : _c('div', [_vm._v("\n                  -\n                ")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "140px !important"
      }
    }, [(row.Candidato != null) ? _c('div', [_vm._v("\n                  " + _vm._s(row.Candidato.CPF) + " \n                ")]) : _c('div', [_vm._v("\n                  -\n                ")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "140px !important"
      }
    }, [_vm._v(_vm._s(_vm.formatarData(row.DataHorario)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "110px !important"
      }
    }, [_vm._v(_vm._s(_vm.statusAtendimento(row.Status)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "110px !important"
      }
    }, [(row.Tipo == 0) ? _c('small', {
      staticClass: "label label-info"
    }, [_vm._v(" Admissão ")]) : _vm._e(), _vm._v(" "), (row.Tipo == 1) ? _c('small', {
      staticClass: "label label-danger"
    }, [_vm._v(" Rescisão ")]) : _vm._e(), _vm._v(" "), (row.Tipo == 2) ? _c('small', {
      staticClass: "label label-default"
    }, [_vm._v(" Outros ")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "110px !important",
        "text-align": "left"
      },
      attrs: {
        "title": row.Observacoes
      }
    }, [_vm._v(_vm._s(row.Observacoes.substring(0, 30)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "130px !important"
      }
    }, [(row.Vaga != null) ? _c('div', [_c('a', {
      attrs: {
        "target": "_blank",
        "href": 'http://fastrhluandre.com.br/Vagas/Visualizar/' + row.Vaga.Id,
        "title": row.Vaga.Id
      }
    }, [_vm._v(" " + _vm._s(row.Vaga.Id) + " ")])]) : _c('div', [_vm._v("\n                  -\n                ")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "110px !important"
      }
    }, [(row.FichaAprovacao != null) ? _c('div', [_c('a', {
      attrs: {
        "target": "_blank",
        "href": 'http://fastrhluandre.com.br/FichaAprovacao/Visualizar/' + row.FichaAprovacao.Id,
        "title": row.FichaAprovacao.Id
      }
    }, [_vm._v(" " + _vm._s(row.FichaAprovacao.Id) + " ")])]) : _c('div', [_vm._v("\n                  -\n                ")])]), _vm._v(" "), _c('td', [(row.FichaAprovacao != null) ? _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selecionados),
        expression: "selecionados"
      }],
      attrs: {
        "type": "checkbox",
        "number": ""
      },
      domProps: {
        "value": row.FichaAprovacao.Id,
        "checked": Array.isArray(_vm.selecionados) ? _vm._i(_vm.selecionados, row.FichaAprovacao.Id) > -1 : (_vm.selecionados)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selecionados,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = row.FichaAprovacao.Id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selecionados = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selecionados = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selecionados = $$c
          }
        }
      }
    })]) : _vm._e()])])
  }), 0)])])]), _vm._v(" "), _c('ModalNaoExportou', {
    attrs: {
      "fichas": _vm.naoExportou
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs",
    attrs: {
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "active",
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#home",
      "aria-controls": "home",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v("Recepção")])]), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#relatorio",
      "aria-controls": "relatorio",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v("Relatório")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-calendar",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-623017ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Recepcao.vue
// module id = 292
// module chunks = 1